<div class="resident-card">
  <div class="resident-header">
    <app-avatar-thumbnail
      [user]="resident"
      [size]="36"
    ></app-avatar-thumbnail>
    <div class="resident-details">
      <div class="resident-name">{{ resident.first_name }} {{ resident.last_name }}</div>
      <div class="resident-status" [class.active]="resident.is_active" [class.inactive]="!resident.is_active">
        {{ resident.is_active ? 'Active' : 'Inactive' }}
      </div>
    </div>
  </div>
  <div class="resident-metrics" *ngIf="residentMetric$ | async as residentMetric">
    <div class="metric messages" [matTooltip]="'COMPONENTS.RESIDENT_DASHBOARD_CARD.MESSAGES' | translate">
      <mat-icon class="metric-icon">mail</mat-icon>
      <span class="metric-value">{{ residentMetric.message_set_count }}</span>
    </div>
    <div class="metric calls" [matTooltip]="'COMPONENTS.RESIDENT_DASHBOARD_CARD.CALLS' | translate">
      <mat-icon class="metric-icon">videocam</mat-icon>
      <span class="metric-value">{{ residentMetric.conferencing_count }}</span>
    </div>
  </div>
</div>
